<span
  class="d-inline-flex align-items-center text-nowrap chip"
  [class]="color ? 'chip--' + color : ''"
  [attr.data-testId]="dataTestId ?? 'chip-icon'"
  [ngClass]="{
    'justify-content-center' : !label,
    'chipPadding' : label,
    'chip--standard' : size === 'standard',
    'chip--small' : size === 'small'
  }"
>
  <mat-icon *ngIf="icon" [svgIcon]="icon"></mat-icon>
  <span *ngIf="label" [ngClass]="{ 'pl-1' : icon }" class="chipLabel font-weight-bold">{{label}}</span>
</span>
